<script lang="ts">
	import pluralize from "pluralize";
	import type { Poll, QuestionStats } from "#gen/forms/v1/poll_pb.js";
	import P from "#lib/components/P.svelte";
	import QuestionResult from "#lib/components/page/components/poll/QuestionResult.svelte";
	import { formatNumber } from "#lib/number.js";
	import type { JsonObject } from "@bufbuild/protobuf";

	interface Props {
		config: JsonObject | undefined;
		poll: Poll;
		results: QuestionStats[];
	}

	let { config, poll, results = [] }: Props = $props();

	const totalPollAnswers = $derived(results.reduce((total, result) => total + Number(result?.totalPollAnswers), 0) ?? 0);
</script>

<div class="flex w-full items-center justify-between gap-4">
	<P align="left" size="lg" weight="semibold" class="text-(--poll-secondary-text-color)">All results</P>
	<div class="rounded-full bg-(--poll-primary-button-background-color) px-4 py-1 text-xs text-(--poll-primary-button-text-color)">{formatNumber(totalPollAnswers)} total {pluralize("vote", totalPollAnswers)}</div>
</div>
<div class="flex w-full flex-col gap-4">
	{#each poll.questions as question, i (i)}
		{@const stats = results.find(r => r?.questionId === question.id)}
		<QuestionResult {config} {poll} {question} {stats} />
	{/each}
</div>
